<template>
  <van-swipe-cell
    class="message-item-wrapper"
    :right-width="item.unread_count ? 180 : 72"
    :left-width=0.01
    :on-close="onSwipeClose"
  >
    <div class="message-item">
      <div class="thumb-icon">
        <svg-icon :icon="`msg-${item.type}`"/>
        <badge v-if="item.unread_count" :content="item.unread_count"/>
      </div>
      <div class="item-content has-border-bottom">
        <div class="message-name">
          <div class="name two-line-ellipsis">{{messageName}}</div>
          <div v-if="messageTime" class="time">{{messageTime}}</div>
        </div>
        <div class="message-content">
          <span class="message-sender-label ellipsis">
            <span v-if="item.include_current_user && item.unread_count > 0" class='include-current-user'>[{{$t('message.list.includeCurrentUser')}}]</span>
            <span v-if="sender_name" class="message-sender" v-html="sender_name + (item.type === 'comment' ? '' : ' ')"></span>
          </span>
          <span :class="['message-recent ellipsis', is_voice && item.unread_count > 0 && 'new-voice']" v-html="message_content"></span>
        </div>
      </div>
    </div>
    <template slot="right">
      <div v-if="item.unread_count" class="mark-read" @click="recordActionName('mark')">{{$t('message.markAsRead')}}</div>
      <div class="delete" @click="recordActionName()">{{$t('base.delete')}}</div>
    </template>
  </van-swipe-cell>
</template>
<script>
import ajax from '@/utils/ajax'
import {formatDate, confirm, mention, escapeHTML} from '@/utils/common'
import {i18n} from '@/utils/i18n'
import {MESSAGES_DELETE, MESSAGES_MARK_READ} from '@/config/api'
import Badge from '../utils/Badge'

export default {
  name: 'MessageItem',
  components: {
    Badge
  },
  props: {
    item: Object
  },
  data () {
    return {
      sender_name: null,
      message_content: null,
      is_voice: false
    }
  },
  computed: {
    messageName () {
      let { type, most_recent_message, item_name } = this.item
      item_name = item_name || most_recent_message.item_name

      if (type === 'collab' && !item_name) {
        return i18n.t('message.type.collab')
      } else {
        return item_name
      }
    },
    messageTime () {
      const {item_time, modified_at} = this.item
      let time = item_time ? formatDate(item_time * 1000, '%R', true, true) : modified_at ? formatDate(modified_at * 1000, '%R', true, true) : null
      const reg = /(\d{4}-\d{2})-\d{2}/
      if (reg.test(time)) {
        time = time.replace(reg, '$1')
      }
      return time
    }
  },
  created () {
    this.formatContent()
  },
  methods: {
    formatContent () {
      let { type, sender_name, most_recent_message } = this.item
      let { is_voice, content, source, collab_type, group_name, invitation_message, message_comments, item_type } = most_recent_message

      let message_content = ''
      let contentDetail

      switch (type) {
        case 'comment':
          sender_name = sender_name || most_recent_message.user_full_name

          if (message_comments) {
            if (message_comments.length > 1) {
              message_content = `<span class="highlight">${i18n.t('message.list.commentRelate', [message_comments.length])}</span>`
            } else {
              contentDetail = message_comments[0].message_comment_content
            }
          } else if (most_recent_message) {
            is_voice = most_recent_message.is_voice
            contentDetail = most_recent_message.content
          } else {
            contentDetail = content
          }
          if (is_voice) {
            this.is_voice = true
            message_content = `${i18n.t('base.colon')}<span class="voice-text">[${i18n.t('message.list.voice')}]</span>`
          } else {
            const content = mention(contentDetail.split(/[\r\n]/g)[0], i18n.t('file.comment.metionAllCollaborators'))
            message_content = `<span class="message-content-detail">${i18n.t('base.colon') + content}</span>`
          }
          break

        case 'share_link':
          sender_name = most_recent_message.sender_full_name

          switch (source) {
            case 1:
              message_content = i18n.t(item_type === 'folder' ? 'message.list.sharedFolderToYou' : 'message.list.sharedFileToYou')
              break
            case 2:
              message_content = i18n.t('message.list.sharing.reopen')
              break
            case 4:
              message_content = i18n.t('message.list.sharing.desc.updated')
              break
          }
          break

        case 'collab':
          sender_name = most_recent_message.sender_name

          if (!collab_type) {
            message_content = i18n.t('message.child.inviteYouToCollab')
          } else if (collab_type === 'group') {
            message_content = i18n.t('message.child.inviteGroupToCollab', [escapeHTML(group_name)])
          } else if (collab_type === 'department') {
            message_content = i18n.t('message.child.inviteDeptToCollab', [escapeHTML(group_name)])
          }
          if (invitation_message) {
            message_content += ': ' + escapeHTML(invitation_message)
          }
          break
      }

      this.sender_name = sender_name
      this.message_content = message_content
    },
    recordActionName (actionName) {
      this.rigthAction = actionName || 'delete'
    },
    markRead (instance) {
      const messageId = this.item.id
      ajax({
        url: MESSAGES_MARK_READ,
        type: 'POST',
        data: {
          message_ids: [messageId]
        }
      }).then(res => {
        if (res && res.success) {
          instance && instance.close()
          this.setState({actionState: {
            action: 'markRead',
            id: messageId
          }})
        }
      })
    },
    onSwipeClose (clickPosition, instance) {
      switch (clickPosition) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close()
          break
        case 'right':
          if (this.rigthAction === 'mark') {
            this.markRead(instance)
          } else {
            const messageId = this.item.id
            this.markRead()
            confirm({
              className: 'dialog danger-dialog',
              title: i18n.t('file.message.delete.confirm'),
              confirmButtonText: i18n.t('base.delete'),
              cancelButtonText: i18n.t('base.cancelText')
            }).then(() => {
              ajax({
                url: MESSAGES_DELETE,
                data: {
                  message_ids: [messageId]
                },
                accept_all_errors: true,
                successMessage: i18n.t('file.message.delete.success')
              }).then(res => {
                instance.close()
                this.$emit('message-delete', messageId)
              })
            }).catch(() => {}) // https://stackoverflow.com/questions/42460039/promise-reject-causes-uncaught-in-promise-warning
          }
          break
      }
    }
  }
}
</script>
<style lang="postcss">
.message-item {
  display: flex;
  box-sizing: border-box;
  min-height: 60px;
  padding: 10px 0 0 15px;
  background-color: #fff;

  & .thumb-icon {
    flex: 0 0 auto;
    position: relative;
    margin-right: 10px;
    margin-top: 5px;

    & .dot {
      position: absolute;
      right: -14px;
      top: -14px;
      min-width: 28px;
      height: 28px;
      border-radius: 14px;
      background-color: #f55;
      font-size: 20px;
      color: #fff;
      text-align: center;
      transform: scale(.5);
      transform-origin: center
    }
  }

  & svg {
    width: 30px;
    height: 30px;
  }

  & .item-content {
    flex: 1 1 auto;
    width: 0;
    padding: 0 15px 10px 0;
  }

  & .message-name {
    display: flex;

    & .name {
      flex: 1 1 auto;
      width: 100px;
      min-height: 22px;
      line-height: 22px;
      font-size: 16px;
    }

    & .time {
      flex: 0 0 auto;
      width: 70px;
      font-size: 12px;
      color: #c1c1c1;
      text-align: right;
    }
  }

  & .message-content {
    display: flex;
    font-size: 12px;
    color: #848484;
    align-items: center;

    & .message-sender-label {
      box-sizing: border-box;
      flex: 0 0 auto;
      max-width: 50%;
    }

    & .message-sender {
      white-space: pre;
      line-break: 1;
    }

    & .message-recent {
      box-sizing: border-box;
      flex: 1 1 auto
    }

    & .new-voice,
    & .include-current-user {
      color: #ff5555;
    }

    & .mention {
      color: #848484;
    }
  }
}

.van-swipe-cell__right {
  display: flex;
  text-align: center;
  color: #fff;

  & .mark-read {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    line-height: 100%;
    width: 108px;
    background-color: #b2b7ca;
  }

  & .delete {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 72px;
    background-color: #f55;
  }
}
</style>
